import { AIMagic } from "@/assets";
import { customTwMerge as twMerge } from "@/helpers/customTwMerge";
import {
  Button,
  CheckCircular,
  InfoIcon,
} from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

import ReadMore from "@/components/common/readMore";
import { SummaryType } from "@/components/profile/profileSummary/types";

type SummaryOptionsProps = {
  summaryOptions: SummaryType[];
  handleInsertedSummary: (i: number) => void;
};

type RenderOptionProps = {
  isOriginal: boolean;
  isInserted: boolean;
  isSelected: boolean;
  handleSelect: (i: number) => void;
  handleInsert: (e: React.MouseEvent<HTMLButtonElement>, i: number) => void;
  index: number;
  summary: SummaryType;
};

const RenderOption = ({
  isOriginal = false,
  isInserted,
  isSelected,
  handleSelect,
  handleInsert,
  index,
  summary,
}: RenderOptionProps) => {
  return (
    <>
      <div
        className={twMerge(
          "border-grey-05 relative flex flex-col gap-[10px] rounded-lg border p-4 text-sm",
          isSelected && "!border-content-strong",
          isInserted && "!border-green-50",
        )}
        onClick={() => handleSelect(index)}
        key={`summary-option-${index}`}
      >
        {isOriginal && (
          <p className="absolute left-1/2 top-0 w-1/3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-green-50 px-2 py-1 text-center text-xs text-white">
            Original
          </p>
        )}
        <ReadMore
          text={summary.summary}
          maxLength={150}
          className="text-grey-3"
        />
        {isSelected && (
          <>
            {isInserted ? (
              <Button
                className="pointer-events-none border-none bg-green-50"
                label="Inserted"
                leftIcon={<CheckCircular height={16} width={16} />}
                modifier="primary"
              />
            ) : (
              <Button
                label="Insert Summary"
                modifier="primary"
                onClick={(e: any) => handleInsert(e, index)}
              />
            )}

            <div className="text-content-tertiary flex items-center gap-1 text-sm">
              <InfoIcon height={24} width={24} />
              <p>
                You will have the option to make edits after inserting this.
              </p>
            </div>
          </>
        )}
      </div>
      {index === 0 && (
        <p
          key="ai-summary-tag"
          className="flex items-end gap-2 text-base font-bold"
        >
          <AIMagic height={24} width={24} /> Ai generated summary
        </p>
      )}
    </>
  );
};

const SummaryOptions = ({
  summaryOptions,
  handleInsertedSummary,
}: SummaryOptionsProps) => {
  const [selectedSummaryIdx, setSelectedSummaryIdx] = useState(-1);
  const [insertedSummaryIdx, setInsertedSummaryIdx] = useState(-1);

  useEffect(() => {
    summaryOptions.forEach((summary, index) => {
      if (summary.usedInProfile) {
        setInsertedSummaryIdx(index);
      }
    });
  }, []);

  const handleSelect = (index: number) => {
    setSelectedSummaryIdx(index);
  };

  const handleInsert = (
    e: React.MouseEvent<HTMLButtonElement>,
    index: number,
  ) => {
    e.stopPropagation();
    setInsertedSummaryIdx(index);
    handleInsertedSummary(index);
  };
  return (
    <div className="flex flex-col gap-4">
      {summaryOptions.map((summary, index) => (
        <RenderOption
          key={index}
          isOriginal={!index}
          isInserted={insertedSummaryIdx === index}
          isSelected={selectedSummaryIdx === index}
          handleSelect={handleSelect}
          handleInsert={handleInsert}
          index={index}
          summary={summary}
        />
      ))}
    </div>
  );
};

export default SummaryOptions;
